import constants from '../constants/actionTypes'

var initialState = {
    records: [],
    record_add_form:{
        hid:'',
        key:'',
        serial_number: '',
        comments:'',
        validation: {
            hid:'',
            serial_number:''
        }
    },
    record_search_form:{
        hid:'',
        serial_number: '',
        search_type: 'by_hid_serial',
        validation: {
            hid:'',
            serial_number:''
        }
    },
    record_add_modal:{
        visible:false,
        hidden_data: false,
        hid:'',
        serial_number: '',
        validation: {
            hid:'',
            serial_number:''
        }
    },
    record_edit_modal:{
        id: '',
        visible:false,
        hidden_data: false,
        hid:'',
        serial_number: '',
        comments:'',
        validation: {
            hid:'',
            serial_number:''
        }
    }
}

export default (state = initialState, action) => {

    var updated = Object.assign({}, state)

    switch(action.type) {
        case constants.RECORD_EDIT_MODAL_OPEN:
            updated['record_edit_modal'] = action.payload
            return updated

        case constants.RECORD_EDIT_MODAL_CHANGE:
            updated['record_edit_modal'] = action.payload
            return updated

        case constants.RECORD_EDIT_MODAL_CLOSE:
            updated['record_edit_modal'] = initialState.record_edit_modal
            return updated
            
        case constants.RECORD_EDIT_FORM_CHANGE:
            updated['record_edit_form'] = action.payload
            return updated

        case constants.RECORD_EDIT_FORM_RESET:
            updated['record_edit_form'] = initialState.record_edit_form
            return updated            

        case constants.RECORD_EDIT_FORM_SUBMIT_START:
            return updated    

        case constants.RECORD_EDIT_FORM_SUBMIT_SUCCESS:
            return updated  

        case constants.RECORD_EDIT_FORM_SUBMIT_ERROR:
            return updated  

        case constants.RECORD_DELETE_FORM_SUBMIT_ERROR:
            return updated    

        case constants.RECORD_DELETE_FORM_SUBMIT_START:
            return updated  

        case constants.RECORD_DELETE_FORM_SUBMIT_SUCCESS:
            return updated 


        case constants.RECORD_ADD_MODAL_OPEN:
            updated['record_add_modal'] = action.payload
            return updated

        case constants.RECORD_ADD_MODAL_CHANGE:
            updated['record_add_modal'] = action.payload
            return updated

        case constants.RECORD_ADD_MODAL_CLOSE:
            updated['record_add_modal'] = initialState.record_add_modal
            return updated
            
        case constants.RECORD_ADD_FORM_CHANGE:
            updated['record_add_form'] = action.payload
            return updated

        case constants.RECORD_ADD_FORM_RESET:
            updated['record_add_form'] = initialState.record_add_form
            return updated            

        case constants.RECORD_ADD_FORM_SUBMIT_START:
            return updated    

        case constants.RECORD_ADD_FORM_SUBMIT_SUCCESS:
            return updated  

        case constants.RECORD_ADD_FORM_SUBMIT_ERROR:
            return updated  

        case constants.RECORD_SEARCH_FORM_CHANGE:
            updated['record_search_form'] = action.payload
            return updated

        case constants.RECORD_SEARCH_FORM_RESET:
            updated['record_search_form'] = initialState.record_search_form;
            return updated    
         
        case constants.RECORDS_FETCHING_START:
            return updated    

        case constants.RECORDS_FETCHING_SUCCESS:
            updated['records'] = action.payload;
            return updated  

        case constants.RECORDS_FETCHING_ERROR:
            return updated 

      default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/recordsReducer.js